import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getOpsColor } from "../../utils/helper";

import { RightArrowIcon } from "../Icons";
import ProgressBar from "../Report/new/ProgressBar/ProgressBar";
import { Button, IconButton } from "../UI";
import {
  CloseIconWrapper,
  OnBoardingFooter,
  OnBoardingWrapper,
  StyledDescription,
  StyledTitle,
} from "./OnBoarding-styled";

const OnBoarding = ({ title, description, total, config, tour, t }) => {
  const layersLoading = useSelector((store) => store.layersLoading);
  const activeModule = useSelector((store) => store.activeModule);
  const currentPosition = useMemo(() => {
    return tour.steps.indexOf(tour.getCurrentStep());
  }, [tour]);

  const opsColor = useMemo(
    () => getOpsColor(config, activeModule),
    [config, activeModule]
  );

  return (
    <div>
      <div style={{ height: 4, position: "relative" }}>
        <ProgressBar
          bgColor="rgba(0,0,0,0.08)"
          currentPosition={currentPosition + 1}
          total={total}
          color={"var(--opsColor)"}
        />
      </div>
      <OnBoardingWrapper>
        <CloseIconWrapper onClick={() => tour.complete()}>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 512 512"
            height="22px"
            width="22px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="32"
              d="M368 368 144 144m224 0L144 368"
            ></path>
          </svg>
        </CloseIconWrapper>
        <StyledTitle>{title}</StyledTitle>
        <StyledDescription>{description}</StyledDescription>
      </OnBoardingWrapper>
      <OnBoardingFooter>
        <IconButton
          style={{
            opacity: tour.steps.indexOf(tour.getCurrentStep()) === 0 ? 0 : 1,
            pointerEvents:
              tour.steps.indexOf(tour.getCurrentStep()) === 0 ? "none" : "auto",
          }}
          onClick={() => {
            const prevSteps = tour.steps.slice(0, currentPosition).reverse();
            const nextStep = prevSteps.find((step) => {
              const element = document.querySelector(
                step.options.attachTo.element
              );
              return !!element;
            });

            if (!nextStep) {
              tour.complete();
            } else {
              tour.show(nextStep.id, false);
            }
          }}
        >
          <RightArrowIcon width={18} color="currentColor" />
        </IconButton>

        <Button
          isNew={true}
          style={{
            position: "relative",
            pointerEvents: layersLoading ? "none" : "",
          }}
          disabled={layersLoading}
          id={`onboarding-next-${tour.getCurrentStep().id}`}
          selected
          loaderColor="#fff"
          onClick={() => {
            const nextSteps = tour.steps.slice(
              currentPosition + 1,
              tour.steps.length
            );

            const nextStep = nextSteps.find((step) => {
              const element = document.querySelector(
                step.options.attachTo.element
              );
              return !!element;
            });

            if (!nextStep) {
              tour.complete();
            } else {
              tour.show(nextStep.id, true);
            }
          }}
        >
          {layersLoading ? (
            <calcite-loader scale="s"></calcite-loader>
          ) : currentPosition === tour.steps.length - 1 ? (
            t("onboarding.buttons.finish")
          ) : (
            t("onboarding.buttons.next")
          )}
        </Button>
      </OnBoardingFooter>
    </div>
  );
};

export default OnBoarding;
